import { Component, OnInit, Input, ElementRef, ComponentRef } from '@angular/core'
import { Arquivo } from '../../_classes/arquivo'
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

@Component({
  selector: 'app-contrato-info',
  templateUrl: './contrato-info.component.html',
  styleUrls: ['./contrato-info.component.scss']
})
export class ContratoInfoComponent implements OnInit {

  contrato: Arquivo
  selfReference: ComponentRef<ContratoInfoComponent>
  exibir: boolean

  mascaraCnpj = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/,]
  mascaraContrato = [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  mascaraDinheiro = createNumberMask({
    prefix: 'R$ ',
    thousandsSeparatorSymbol: '.',
    decimalSymbol: ',',
    decimalLimit: 2,
    allowDecimal: true,
    suffix: ''
  })

  constructor() {
  }

  ngOnInit() {
    this.contrato.cnpj = this.contrato.cnpj || ''
    this.contrato.numeroContrato = this.contrato.numeroContrato || ''
    this.contrato.primeiroAditivo = this.contrato.primeiroAditivo || ''
    this.contrato.segundoAditivo = this.contrato.segundoAditivo || ''
  }

  alterarVisibilidade() {
    this.exibir = !this.exibir
  }

  destruir() {
    this.selfReference.destroy();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/contrato-info/contrato-info.component.ts